export const initialState = {
  open: false,
  message: '',
  type: 'success',
};
